import { useNavigate } from "react-router-dom";
import {
  Card,
  CardContent,
  Typography,
  Stack,
  IconButton,
  Avatar,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

// css comes in SubjectDatealiCM.css

const Pre_added = ({ data, supplement, setDeleteConfirm, send, date, standard, section }) => {
  const navigate = useNavigate();
  const handleSupplementDelete = async (data) => {
    setDeleteConfirm(true);
    let body = {
      type: data.type,
      supplement,
    };
    send(body);
  };
  const isDateLessThanCurrent = (dateString) => {
    if (!dateString) return false;

    const passedDate = new Date(dateString);
    const currentDate = new Date();

    return passedDate < currentDate;
  };
  return (
    <>
      {/* <div className="Class_CM mt-4 ">Pre-read</div> */}
      {/* <div className="d-flex justify-content-between total_studyMaterial">
        <div
          className="d-flex align-items-center gap-2"
          onClick={() => {
            navigate("/PublishedQListPreRead", {
              state: { publishPre_id: data?.id },
            });
          }}
        >
          <div>
            <img
              className="cm_icon"
              src="/ContentM_images/preread_cm.svg"
              alt="preRead logo"
            ></img>
          </div>
          <span className="steram_preread">{data?.name}</span>
        </div>
        {!isDateLessThanCurrent(date) && (
          <div
            className="deleteIcon"
            onClick={() => {
              handleSupplementDelete(data);
            }}
          >
            <img src="/ContentM_images/delete.svg" alt="menu dots logo"></img>
          </div>
        )}
      </div> */}
      <Card
        variant="outlined"
        sx={{
          borderRadius: 2,
          mb: 2,
          boxShadow: 2,
          width: "80%",
          minHeight: 80,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <CardContent sx={{ py: 0.5, px: 2 }}>
          {/* Header */}
          <Typography
            variant="subtitle2"
            fontWeight={600}
            color="primary.main"
            gutterBottom
          >
            Pre-read
          </Typography>

          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            {/* Left Side */}
            <Stack
              direction="row"
              alignItems="center"
              spacing={1.5}
              onClick={() =>
                navigate("/PublishedQListPreRead", {
                  state: { 
                    publishPre_id: data?.id,
                    supplement_id: supplement, 
                    standard: standard, 
                    section: section 
                  },
                })
              }
              sx={{ cursor: "pointer" }}
            >
              <img
                className="cm_icon"
                src="/ContentM_images/preread_cm.svg"
                alt="preRead logo"
              ></img>
              <Typography variant="body1" fontWeight={500}>
                {data?.name}
              </Typography>
            </Stack>

            {/* Delete Icon */}
            {!isDateLessThanCurrent(date) && (
              <IconButton
                onClick={() => handleSupplementDelete(data)}
                color="error"
                size="medium" // ✅ thoda bada button
              >
                <DeleteIcon />
              </IconButton>
            )}
          </Stack>
        </CardContent>
      </Card>
    </>
  );
};

export default Pre_added;
